module.exports = __webpack_public_path__ + "img/undertakingCases14.ba9cac0b.jpg";